import type { FaireProductEntity } from "../../entity_types/product";

export const catalog_prod_prod_72: FaireProductEntity = {
  token: "catalog_prod_prod-72",
  type: "product",
  name: "Woven Rattan Storage Basket - Style 3",
  brandName: "Audrey's Home & Gift",
  imageUrl:
    "https://images.unsplash.com/photo-1616486338812-3dadae4b4ace?w=400&h=400&fit=crop",
  priceDollars: 30.09,
  msrpDollars: 75.22,
  sku: "JA0072",
  caseSize: 2,
  material: "Metal",
  collectionToken: "col_japandi",
  isNew: false,
  isBestseller: false,
  isPreviouslyOrdered: false,
  inStock: true,
  stockLevel: 54,
  description: "Beautiful Japandi piece perfect for any home.",
  categoryTokens: ["catalog_cat_games-puzzles"],
  tags: [],
  brandToken: "catalog_brand_audreys_home_gift",
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "common-sets-db-backfill",
  },
};
